export const StorageEnum = {
  ACCESS_TOKEN: 'access_token',
  USER_INFO: 'user_info',
  USER_ROLE: 'user_role',
  PARENT_ACCESS_TOKEN: 'parent_access_token',
};
